import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, max = 100, ...props }, ref) => {
  // O `value` vai ao Radix para ele escrever o `aria-valuenow`. O Radix escreve
  // `console.error` (inclusive em produção) e ignora o valor fora de 0–max ou
  // NaN; há uso real fora da faixa (cota de armazenamento acima de 100%). Por
  // isso: acima do máximo enche, abaixo de 0 esvazia, NaN fica indeterminada.
  const valor =
    typeof value === "number" && !Number.isNaN(value) ? Math.min(Math.max(value, 0), max) : null;
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className)}
      value={valor}
      max={max}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 bg-primary transition-all"
        style={{ transform: `translateX(-${100 - ((valor ?? 0) * 100) / max}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
